export default __webpack_public_path__ + "static/media/shop-slide-02.973342e2.jpg";